import { RegionProps } from '@/models/props/LocalizationProps';

const Region: RegionProps = {
    pl: 'Poland',
    de: 'German',
    en: 'England'
};

export default Region;
